import React from "react";
import {
  Box, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Typography, Chip,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ASSET_LABELS = {
  final_url: "Final URL",
  business_name: "Business Name",
  headline: "Headline",
  description: "Description",
  sitelink: "Sitelink",
  callout: "Callout",
  structured_snippet: "Structured Snippet",
  display_path: "Display Path",
  phone_call: "Phone Call",
};

const BulkUploadPreview = ({ rows, validationErrors }) => {
  if (!rows || rows.length === 0) return null;

  const validCount = validationErrors.filter((e) => e === null).length;
  const invalidCount = validationErrors.filter((e) => e !== null).length;

  return (
    <Box className="bulk-upload-preview">
      <Box display="flex" gap={2} mb={2}>
        <Chip icon={<CheckCircleOutlineIcon />} label={`${validCount} valid`} color="success" variant="outlined" size="small" />
        <Chip icon={<ErrorOutlineIcon />} label={`${invalidCount} invalid`} color="error" variant="outlined" size="small" />
        <Typography variant="body2" color="text.secondary" sx={{ alignSelf: "center" }}>
          {rows.length} total rows
        </Typography>
      </Box>

      <TableContainer sx={{ maxHeight: 380, border: "1px solid #e0e0e0", borderRadius: "6px" }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, fontSize: "11px", fontFamily: "Inter" }}>ROW</TableCell>
              <TableCell sx={{ fontWeight: 600, fontSize: "11px", fontFamily: "Inter" }}>TYPE</TableCell>
              <TableCell sx={{ fontWeight: 600, fontSize: "11px", fontFamily: "Inter" }}>CONTENT</TableCell>
              <TableCell sx={{ fontWeight: 600, fontSize: "11px", fontFamily: "Inter" }}>STATUS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => {
              const error = validationErrors[idx];
              const isValid = error === null;
              const content =
                row.assetType === "sitelink"
                  ? `${row.sitelinkText || ""} | ${row.description1 || ""} | ${row.description2 || ""} | ${row.finalURL || ""}`
                  : row.assetType === "phone_call"
                  ? `${row.phoneNumber || ""} (${row.countryCode || ""})`
                  : row.assetType === "display_path" && row.pathId
                  ? `${row.pathId === "path1" ? "Path 1" : "Path 2"}: ${row.text || ""}`
                  : row.text || "";

              return (
                <TableRow key={idx} sx={{ backgroundColor: isValid ? "inherit" : "#fff5f5", "&:hover": { backgroundColor: isValid ? "#f9f9f9" : "#ffe8e8" } }}>
                  <TableCell sx={{ fontSize: "12px", fontFamily: "Inter", width: 50 }}>{row._rowIndex}</TableCell>
                  <TableCell sx={{ fontSize: "12px", fontFamily: "Inter", width: 120 }}>
                    <Chip label={ASSET_LABELS[row.assetType] || row.assetType} size="small" sx={{ fontSize: "10px", height: 20 }} />
                  </TableCell>
                  <TableCell sx={{ fontSize: "12px", fontFamily: "Inter", maxWidth: 300, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {content}
                  </TableCell>
                  <TableCell sx={{ fontSize: "11px", fontFamily: "Inter", width: 200 }}>
                    {isValid ? (
                      <Box display="flex" alignItems="center" gap={0.5} color="#2e7d32">
                        <CheckCircleOutlineIcon sx={{ fontSize: 14 }} /> Valid
                      </Box>
                    ) : (
                      <Box color="#d32f2f" display="flex" alignItems="center" gap={0.5}>
                        <ErrorOutlineIcon sx={{ fontSize: 14 }} />
                        <Typography variant="caption" color="error">{error}</Typography>
                      </Box>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BulkUploadPreview;